import React from "react";
import { Check, Mail } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { pageBanner } from "../mock";
import { translations } from "../translations";
import { useLanguage } from "../context/LanguageContext";

const JoinUs = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const c = t.careers;

  return (
    <div>
      <PageHero title={c.pageTitle} image={pageBanner} />

      <section className="py-20 bg-white">
        <div className="max-w-[900px] mx-auto px-5 lg:px-8 text-center">
          <Reveal>
            <h2 className="font-serif text-3xl md:text-4xl font-bold brand-navy dash-center">{c.heading}</h2>
          </Reveal>
          <div className="mt-10 space-y-5 text-left">
            {c.intro.map((p, i) => (
              <Reveal key={i} delay={i * 70}><p className="text-slate-600 leading-relaxed">{p}</p></Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-20 bg-white">
        <div className="max-w-[900px] mx-auto px-5 lg:px-8">
          <Reveal>
            <div className="bg-steel rounded-sm p-9 lg:p-12">
              <h3 className="font-serif text-2xl font-bold text-white dash">{c.whyTitle}</h3>
              <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-4">
                {c.whyPoints.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-white/90">
                    <span className="shrink-0 w-6 h-6 rounded-full bg-sky-accent text-white flex items-center justify-center mt-0.5"><Check size={14} /></span>
                    <span className="leading-relaxed">{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="text-center mt-14">
              <p className="text-slate-600">{c.resumeLabel}</p>
              <a href={`mailto:${c.email}`} className="pill-btn mt-5">
                <Mail size={16} /> {c.email}
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default JoinUs;
